<template>
    <div class='spinner-container'>
        <div class='spinner' />
    </div>
</template>

<script>
export default {
    name: 'BtnLoadingSpinner',
};
</script>

<style scoped>
.spinner-container {
    width: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    position: relative;
    /*top: 50%;*/
    /*left: 50%;*/
    /*margin-top: -16px;*/
    /*margin-left: 16px;*/
    box-sizing: border-box;
}

.spinner {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 5px solid #e0e0e0;
    border-bottom: 5px solid #fe9616;
    animation: spin 1s linear infinite;
    position: relative;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
